(function () {
  'use strict';

  if (window.console && console.info) console.info('[mt-samenstellen] script geladen v7');

  function init() {
    var root = document.getElementById('mt-samenstellen');
    if (!root || root.dataset.mtInit === '1') return;
    root.dataset.mtInit = '1';

    document.body.classList.add('mt-cfg-actief');

    var fotos = leesJson('mt-cfg-fotos', {});
    var config = leesJson('mt-cfg-config', {});
    var productTitel = config.titel || document.title;
    var standaardLevertijd = root.dataset.standaardLevertijd || 'Gratis bezorgd binnen 7 werkdagen';

    var elKeuze = document.getElementById('mt-cfg-keuze');
    var elTotaal = document.getElementById('mt-cfg-totaal');
    var elLever = document.getElementById('mt-cfg-levertijd');
    var elLeverTekst = document.getElementById('mt-cfg-levertijd-tekst');
    var elLinks = document.getElementById('mt-cfg-links');
    var elBtn = document.getElementById('mt-cfg-btn');
    var elFout = document.getElementById('mt-cfg-fout');

    var gekozen = { blad: null, poot: null };
    var origineleFoto = null;
    var huidigeCombiFoto = null;
    var elTegelFoto = document.getElementById('mt-cfg-fototegel-foto');
    var elTegelImg = document.getElementById('mt-cfg-fototegel-img');
    var elTegelLeeg = document.getElementById('mt-cfg-fototegel-leeg');
    var toonFotoInTegel = window.matchMedia('(min-width: 750px)');

    function leesJson(id, fallback) {
      var el = document.getElementById(id);
      if (!el) return fallback;
      try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
    }

    function euro(centen) {
      return '\u20AC\u00A0' + (centen / 100).toFixed(2).replace('.', ',');
    }

    function hoofdfotoElement() {
      var selectors = [
        '.product__media-wrapper .product__media img',
        '.product__media img',
        '.product-media img',
        '[data-product-single-media-wrapper] img',
        '.product__media-list img',
        '.product-gallery img'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el) return el;
      }
      return null;
    }

    function wisselFoto(url) {
      var img = hoofdfotoElement();
      if (!img) return;
      if (origineleFoto === null) origineleFoto = img.getAttribute('src');
      if (!url) return;
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-src');
      img.setAttribute('src', url);
      img.classList.add('loaded');
    }

    function toonLevertijd(b, p) {
      if (!elLever || !elLeverTekst) return;

      var uitVoorraad = [];
      if (b && b.dataset.voorraad === '0') uitVoorraad.push(b);
      if (p && p.dataset.voorraad === '0') uitVoorraad.push(p);

      if (uitVoorraad.length === 0) {
        var traagstOpVoorraad = [b, p].filter(Boolean).sort(function (x, y) { return (parseInt(y.dataset.rang, 10) || 3) - (parseInt(x.dataset.rang, 10) || 3); })[0];
        /* traagste bezorgmethode bepaalt (data-rang 1 = PostNL, 2 = Max/XXL, 3 = Starfurn-75) */
        elLeverTekst.innerHTML = 'Op voorraad \u00B7 ' + ((traagstOpVoorraad && traagstOpVoorraad.dataset.levertijd) || standaardLevertijd);
        elLever.classList.remove('product-inventory-notice--backorder');
        elLever.classList.add('product-inventory-notice--normal');
        return;
      }

      var traagste = uitVoorraad[0];
      for (var i = 1; i < uitVoorraad.length; i++) {
        if ((uitVoorraad[i].dataset.levertijd || '').length >
            (traagste.dataset.levertijd || '').length) {
          traagste = uitVoorraad[i];
        }
      }
      var wat = uitVoorraad.length === 2
        ? 'Tafelblad en tafelpoot'
        : (traagste.dataset.type === 'blad' ? 'Dit tafelblad' : 'Deze tafelpoot');

      elLeverTekst.innerHTML = wat + ' is niet op voorraad \u00B7 ' +
        (traagste.dataset.levertijd || standaardLevertijd) +
        ' \u00B7 wordt compleet bezorgd';
      elLever.classList.remove('product-inventory-notice--normal');
      elLever.classList.add('product-inventory-notice--backorder');
    }

    function vulTegel() {
      if (!elTegelFoto || !elTegelImg || !elTegelLeeg) return;
      var toon = huidigeCombiFoto && toonFotoInTegel.matches;
      if (toon) {
        elTegelImg.src = huidigeCombiFoto;
        elTegelImg.alt = 'Jouw samengestelde eettafel';
        elTegelFoto.hidden = false;
        elTegelLeeg.hidden = true;
      } else {
        elTegelFoto.hidden = true;
        elTegelLeeg.hidden = false;
      }
    }

    if (toonFotoInTegel.addEventListener) {
      toonFotoInTegel.addEventListener('change', vulTegel);
    }

    function update() {
      var b = gekozen.blad;
      var p = gekozen.poot;

      toonLevertijd(b, p);

      if (!b || !p) {
        elKeuze.textContent = !b && !p
          ? 'Kies eerst een tafelblad en een tafelpoot'
          : (!b ? 'Kies nog een tafelblad' : 'Kies nog een tafelpoot');
        elLinks.innerHTML = '';
        elBtn.disabled = true;
        return;
      }

      var totaal = parseInt(b.dataset.prijs, 10) + parseInt(p.dataset.prijs, 10);
      elTotaal.textContent = euro(totaal);
      elKeuze.textContent = productTitel + ' \u00B7 ' + b.dataset.naam +
        ' blad \u00B7 ' + p.dataset.naam;

      elLinks.innerHTML =
        '<a href="' + b.dataset.url + '">Bekijk het tafelblad</a> \u00B7 ' +
        '<a href="' + p.dataset.url + '">Bekijk de tafelpoot</a>';

      huidigeCombiFoto = fotos[b.dataset.kleur + '|' + p.dataset.fotokey] || null;
      wisselFoto(huidigeCombiFoto);
      vulTegel();
      elBtn.disabled = false;
    }

    var modal = document.getElementById('mt-cfg-modal');

    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    function vulModal(knop) {
      document.getElementById('mt-cfg-modal-titel').textContent = knop.dataset.modalTitel || '';
      document.getElementById('mt-cfg-modal-prijs').textContent = knop.dataset.modalPrijs || '';
      document.getElementById('mt-cfg-modal-oms').textContent = knop.dataset.modalOms || '';
      document.getElementById('mt-cfg-modal-lever').textContent = knop.dataset.modalLevertijd || '';
      var img = document.getElementById('mt-cfg-modal-foto');
      if (knop.dataset.modalFoto) {
        img.src = knop.dataset.modalFoto;
        img.alt = knop.dataset.modalTitel || '';
        img.parentElement.hidden = false;
      } else {
        img.parentElement.hidden = true;
      }
      var link = document.getElementById('mt-cfg-modal-link');
      link.href = knop.dataset.modalUrl || '#';
      link.style.display = '';
    }

    function openModal(knop) {
      if (!modal) return;
      vulModal(knop);
      modal.classList.remove('mt-cfg__modal--popover');
      var venster = modal.querySelector('.mt-cfg__modal-venster');
      venster.style.top = '';
      venster.style.left = '';
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function openFotoModal() {
      if (!modal) return;
      var b = gekozen.blad, p = gekozen.poot;
      var titel = productTitel;
      if (b && p) titel += ' \u00B7 ' + b.dataset.naam + ' blad \u00B7 ' + p.dataset.naam;

      document.getElementById('mt-cfg-modal-titel').textContent = titel;
      document.getElementById('mt-cfg-modal-prijs').textContent = '';
      document.getElementById('mt-cfg-modal-oms').textContent = (b && p)
        ? ''
        : 'Kies eerst een tafelblad en een tafelpoot om jouw samenstelling te zien.';
      document.getElementById('mt-cfg-modal-lever').textContent = '';
      document.getElementById('mt-cfg-modal-link').style.display = 'none';

      var img = document.getElementById('mt-cfg-modal-foto');
      var bron = huidigeCombiFoto || origineleFoto ||
        (hoofdfotoElement() ? hoofdfotoElement().getAttribute('src') : '');
      if (bron) {
        img.src = bron;
        img.alt = titel;
        img.parentElement.hidden = false;
      } else {
        img.parentElement.hidden = true;
      }
      modal.classList.remove('mt-cfg__modal--popover', 'mt-cfg__modal--zoom');
      modal.classList.add('mt-cfg__modal--groot');
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function sluitModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.classList.remove('mt-cfg__modal--popover', 'mt-cfg__modal--zoom', 'mt-cfg__modal--groot');
      document.body.style.overflow = '';
      var venster = modal.querySelector('.mt-cfg__modal-venster');
      venster.style.top = '';
      venster.style.left = '';
      venster.style.bottom = '';
    }

    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-modal-sluit]')) sluitModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) sluitModal();
      });
    }

    document.addEventListener('click', function (e) {
      var infoKnop = e.target.closest('.mt-cfg__info');
      if (infoKnop) {
        e.preventDefault();
        modal.classList.remove('mt-cfg__modal--groot', 'mt-cfg__modal--zoom');
        openModal(infoKnop);
        return;
      }
      if (e.target.closest('#mt-cfg-fototegel')) { e.preventDefault(); openFotoModal(); return; }
      if (e.target.closest('#mt-cfg-modal-foto')) {
        modal.classList.toggle('mt-cfg__modal--zoom');
      }
    });

    root.addEventListener('click', function (e) {
      var kaart = e.target.closest('.mt-cfg__card');
      if (!kaart || !root.contains(kaart)) return;

      var type = kaart.dataset.type;
      var kaarten = root.querySelectorAll('.mt-cfg__card[data-type="' + type + '"]');
      for (var i = 0; i < kaarten.length; i++) {
        kaarten[i].classList.remove('is-active');
        kaarten[i].setAttribute('aria-pressed', 'false');
      }
      kaart.classList.add('is-active');
      kaart.setAttribute('aria-pressed', 'true');

      gekozen[type] = kaart;
      elFout.hidden = true;
      update();
    });

    elBtn.addEventListener('click', function () {
      var b = gekozen.blad;
      var p = gekozen.poot;
      if (!b || !p) return;

      var setId = 'set-' + Date.now().toString(36);
      var omschrijving = productTitel + ' \u2013 ' + b.dataset.naam +
        ' blad + ' + p.dataset.naam;

      elBtn.disabled = true;
      elBtn.textContent = 'Bezig met toevoegen...';
      elFout.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(b.dataset.id, 10),
              quantity: 1,
              properties: {
                '_set': setId,
                '_onderdeel': 'tafelblad',
                'Samengestelde tafel': omschrijving
              }
            },
            {
              id: parseInt(p.dataset.id, 10),
              quantity: 1,
              properties: {
                '_set': setId,
                '_onderdeel': 'tafelpoot',
                'Samengestelde tafel': omschrijving
              }
            }
          ]
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        })
        .then(function () {
          elBtn.textContent = 'Toegevoegd aan winkelwagen';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          window.setTimeout(function () { window.location.href = '/cart'; }, 500);
        })
        .catch(function () {
          elBtn.disabled = false;
          elBtn.textContent = 'Voeg jouw tafel toe';
          elFout.hidden = false;
          elFout.textContent =
            'Het toevoegen is niet gelukt. Probeer het opnieuw of neem contact met ons op.';
        });
    });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();